interface Props {
  type: string;
  summary: string;
  onReturn: () => void;
  onDownloadLog?: () => void;
}

const RESULT_LABELS: Record<string, { label: string; className: string }> = {
  diplomatic_success:  { label: "DIPLOMATIC SUCCESS",  className: "result-success" },
  diplomatic_failure:  { label: "DIPLOMATIC FAILURE",  className: "result-failure" },
  combat_victory:      { label: "COMBAT VICTORY",      className: "result-success" },
  combat_defeat:       { label: "DEFEAT",              className: "result-failure" },
  retreat:             { label: "TACTICAL WITHDRAWAL",  className: "result-neutral" },
  objective_complete:  { label: "OBJECTIVE COMPLETE",   className: "result-success" },
  stalemate:           { label: "STALEMATE",            className: "result-neutral" },
};

export function MissionDebrief({ type, summary, onReturn, onDownloadLog }: Props) {
  const result = RESULT_LABELS[type] ?? { label: type.toUpperCase().replace(/_/g, " "), className: "result-neutral" };

  return (
    <div className="debrief-overlay">
      <div className="debrief-panel">
        <div className="debrief-header">MISSION DEBRIEF</div>
        <div className={`debrief-result ${result.className}`}>{result.label}</div>
        <div className="debrief-summary">{summary}</div>
        <div className="debrief-actions">
          <button className="debrief-btn" onClick={onReturn}>
            RETURN TO GALACTIC COMMAND
          </button>
          {onDownloadLog && (
            <button className="debrief-btn debrief-btn-secondary" onClick={onDownloadLog}>
              DOWNLOAD MISSION LOG
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
